export default __webpack_public_path__ + "static/media/VarelaRound-Regular.7f26fef7.woff";